export const borderRadius = "0.25rem";
export const boxShadow = "0 4px 6px 0 rgba(0,0,0,0.2)";
